module.exports = __webpack_public_path__ + "img/07李燚东.f36f4024.jpg";